
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import * as React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
// import { Icons } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox"
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@/components/ui/input-otp"
import { ArrowLeft, Loader2 } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { makeRequest } from "@/utils/axiosInterceptor";
import he from 'he';
import { v4 as uuidv4 } from "uuid";

export function LoginForm({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"form">) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [uname, setUname] = React.useState("");
  const [pwd, setPwd] = React.useState("");
  const [mfa, setMfa] = React.useState(false)
  const [disableResend, setDisableResend] = React.useState(true)
  const [disableOtpSubmit, setDisableOtpSubmit] = React.useState(true)
  const [timer, setTimer] = React.useState(60);
  const [eneteredOtp, setEnteredOtp] = React.useState("")
  const fingerprint_key = uuidv4();
  const [showPassword, setShowPassword] = React.useState(false);
  

  React.useEffect(() => {
    if (timer > 0) {
      const intervalId = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);

      return () => clearInterval(intervalId); // Clear interval on component unmount
    } else {
      setDisableResend(false);
    }
  }, [timer]);

  React.useEffect(() => {
    const getLoggedInUser = async () => {
      try{
        const res = await makeRequest('GET', '/auth/alive', '')
        console.log(res)
        if (res.status === 200) {
          if (res.data === 'alive') {
            // localStorage.setItem('username', res.data.username);
            navigate("/dashboard");
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
    getLoggedInUser()
   
  }, [])

  function sanitizeObject(input) {
    if (!input || typeof input !== 'object') {
      throw new Error('Input must be an object or array.');
    }
  
    const sanitizeValue = (value) => {
      if (typeof value === 'string') {
        // Decode HTML entities, then sanitize
        const decodedValue = he.decode(value);
        return decodedValue.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
      } else if (typeof value === 'number') {
        return value; // Numbers are safe, return as-is
      } else if (Array.isArray(value)) {
        return value.map(sanitizeValue); // Recursively sanitize arrays
      } else if (typeof value === 'object' && value !== null) {
        return sanitizeObject(value); // Recursively sanitize nested objects
      }
      return value; // Leave other types as-is
    };
  
    const sanitizedObject = {};
    for (const key of Object.keys(input)) {
      sanitizedObject[key] = sanitizeValue(input[key]);
    }
    return sanitizedObject;
  }

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    sessionStorage.setItem("fingerprint_key", fingerprint_key)
    if (uname !== "" && pwd !== "") {
      const values = {
        username: uname,
        password: pwd,
        fingerprint_key
      };
      try {
        const res = await axios.post(
          "/auth/login",
          sanitizeObject(values),
          { withCredentials: true }
        );
        console.log(res)
        if (res.status === 200) {
          // Save token to localStorage for authenticated requests
          if (res.data.token) {
            localStorage.setItem("token", res.data.token);
          }
          localStorage.setItem("username", values.username);
          
          if (res.data.mfa) {
            const getMfaRes = await axios.post(
              "/auth/getmfa",
              {
                username: values.username
              },
              { withCredentials: true }
            )
            if (getMfaRes.status === 201) {
              if (getMfaRes.data.msg === "Otp sent.") {
                setMfa(true);
                setDisableResend(true);
                setTimer(60);

              } else {
                toast.error("Error logging in.", {
                  description: `Your admin has enabled Multi-factor Authentication for you, but cannot find your
                   credentials please contact your administarator or lenek support.`,
                  action: {
                    label: "Close",
                    onClick: () => { },
                  },
                });
              }
            } else {
              toast.error("Error logging in.", {
                description: `Your admin has enabled Multi-factor Authentication for you, but cannot find your
                 credentials please contact your administarator or lenek support.`,
                action: {
                  label: "Close",
                  onClick: () => { },
                },
              });
            }
          } else {
            navigate("/dashboard");
          }
          // localStorage.removeItem('worklistFilters');
          // localStorage.removeItem('triageFilters');
          // localStorage.setItem("username", values.username);
          // navigate("/dashboard");
          // localStorage.setItem("admin", res.data.isAdmin);
          // localStorage.setItem("token", res.data.token);

        } else {
          console.log(res)
        }
      } catch (error: any) {
        console.log(error)
        if (error.response.data.message === "Unauthorized" && error.response.status === 401) {
          toast.error("Incorrect username or password.", {
            action: {
              label: "Close",
              onClick: () => { },
            },
          });
        }
        if (error.response.data.message === "User blocked" && error.response.status === 401) {
          toast.error("Account blocked", {
            description: `Your account has been blocked due to multiple unsuccesful attempts.
            Please contact your administrator or try after 12hrs.`,
            action: {
              label: "Close",
              onClick: () => { },
            },
          });
        }

      }
    } else {
      toast.error("Please enter username and password.", {
        action: {
          label: "Close",
          onClick: () => { },
        },
      });
    }
    setIsLoading(false);
  };

  const resendOtp = async () => {
    try {
      setDisableResend(true);
      setMfa(true);
      setTimer(60);
      setDisableOtpSubmit(true);
      const getMfaRes = await axios.post(
        "/auth/getmfa",
        {
          username: uname
        },
        { withCredentials: true }
      )
      if (getMfaRes.status === 201) {
        if (getMfaRes.data.msg === "Otp sent.") {
          toast.success("OTP resent.", {
            description: `OTP has been resent to your registered email address.`,
            action: {
              label: "Close",
              onClick: () => { },
            },
          });
        } else {
          toast.error("Error resending OTP", {
            description: `There was an error while resending the OTP, please try again or contact your administrator.`,
            action: {
              label: "Close",
              onClick: () => { },
            },
          });
        }
      }
    } catch (err) {
      toast.error("Error resending OTP", {
        description: `There was an error while resending the OTP, please try again or contact your administrator.`,
        action: {
          label: "Close",
          onClick: () => { },
        },
      });
    }

  }


  const onOtpInputChange = (otp: string) => {
    setEnteredOtp(otp)
    if (otp.length === 6) {
      setDisableOtpSubmit(false)
    } else {
      setDisableOtpSubmit(true)
    }
  }

  const submitOtp = async () => {
    try {
      const res = await axios.post(
        "/auth/verifymfa",
        {
          username: uname,
          otp: eneteredOtp,
          fingerprint_key
        },
        { withCredentials: true }
      )
      if (res.status === 201) {
        localStorage.setItem("username", uname);
        navigate("/dashboard");
      }
    } catch (err: any) {
      if (err.response.data.message === "Incorrect OTP Try Again.") {
        toast.error("Incorrect OTP", {
          description: `OTP you entered is either incorrect or expired. Please try again.`,
          action: {
            label: "Close",
            onClick: () => { },
          },
        });
      }

    }
  }

  const displayPassword = (event: any) => {
    setShowPassword(event);
  }

  return (
    <div className={cn("grid gap-6 h-[25vh]", className)} {...props}>
      {!mfa ?
        <div>
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
            <div className="flex flex-col space-y-2 text-center">
              <p className="text-sm text-muted-foreground">
                Enter your username and password to login.
              </p>
            </div>
          </div>
          <form onSubmit={onSubmit}>
            <div className="grid gap-2 mt-[2vh]">
              <div className="grid gap-1">

                <Label
                  data-test="userid-input-label"
                  className="sr-only"
                  htmlFor="username"
                >
                  Username
                </Label>
                <Input
                  data-test="userid-input"
                  value={uname}
                  onChange={(e) => setUname(e.target.value)}
                  id="username"
                  placeholder="Username"
                  type="text"
                  autoCapitalize="none"
                  autoComplete="username"
                  autoCorrect="off"
                  disabled={isLoading}
                />
                <Label
                  data-test="password-input-label"
                  className="sr-only"
                  htmlFor="password"
                >
                  Password
                </Label>
                <Input
                  data-test="password-input"
                  value={pwd}
                  onChange={(e) => setPwd(e.target.value)}
                  id="password"
                  placeholder="Password"
                  type={showPassword? "text": "password"}
                  autoCapitalize="none"
                  autoComplete="off"
                  autoCorrect="off"
                  disabled={isLoading}
                />
                <div className="flex items-center space-x-2 mt-[1vh] w-[100%]">
                  <Checkbox checked={showPassword} onCheckedChange={(e) => displayPassword(e)} id="terms" />
                  <label
                    htmlFor="terms"
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                  >
                    Show Password
                  </label>
                </div>
              </div>
              <Button
                type="submit"
                data-test="login-button"
                className="mt-[3vh]"
                disabled={isLoading}
              >
                {isLoading && (
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                )}
                Login
              </Button>
            </div>
          </form>
        </div>
        :
        <div className=""
          style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
        >
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
            <div className="flex flex-col space-y-2 text-center">
              <p className="text-sm text-muted-foreground">
                Please enter the OTP sent to your registered email.
              </p>
            </div>
          </div>
          <div className="mt-[2vh]">
            <InputOTP onChange={(otp) => onOtpInputChange(otp)} maxLength={6}>
              <InputOTPGroup>
                <InputOTPSlot index={0} />
                <InputOTPSlot index={1} />
                <InputOTPSlot index={2} />
              </InputOTPGroup>
              <InputOTPSeparator />
              <InputOTPGroup>
                <InputOTPSlot index={3} />
                <InputOTPSlot index={4} />
                <InputOTPSlot index={5} />
              </InputOTPGroup>
            </InputOTP>
          </div>
          <div className="mt-[3vh] w-[60%] flex" style={{ alignItems: 'center', justifyContent: 'space-around' }} >
            <Button onClick={submitOtp} disabled={disableOtpSubmit}>Submit</Button>
            <Button onClick={resendOtp} disabled={disableResend}>Resend OTP</Button>
          </div>
          <div className="mt-[1vh]">
            <p className="text-sm text-muted-foreground">
              {disableResend && `Resent OTP in : ${timer}s`}
            </p>
          </div>
          <p className="text-xs text-destructive">
            OTP expires in 2 minutes.
          </p>
          <div className="mt-[1vw]">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <Button
                    variant="outline"
                    size="icon"
                    data-cy="header-back"
                    onClick={() => setMfa(false)}
                  >
                    <ArrowLeft />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Back to login</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>

        </div>
      }
    </div>
  );
}
